"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableTrackingService = void 0;
class DeliverableTrackingService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Updates goal for a tracked deliverable
     * @param deliverableId
     * @param requestBody
     * @returns DeliverableResponse
     * @throws ApiError
     */
    updateDeliverableGoal(deliverableId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/tracking/{deliverableId}',
            path: {
                'deliverableId': deliverableId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Updates goal progress for multiple deliverables for a given deployment
     * @param deploymentId
     * @param requestBody
     * @returns DeliverablesResponse
     * @throws ApiError
     */
    updateDeliverableGoals(deploymentId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/tracking/deployment/{deploymentId}',
            path: {
                'deploymentId': deploymentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns the full tree of entities down to a given deployment
     * @param deploymentId
     * @returns DeploymentTreeResponse
     * @throws ApiError
     */
    getDeploymentTree(deploymentId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/tracking/deployment/{deploymentId}',
            path: {
                'deploymentId': deploymentId,
            },
        });
    }
    /**
     * Returns the full tree of entities for all deployments matching a given criteria
     * @param deliverableType Deliverable type
     * @param states Deplayment states list
     * @returns DeploymentsTreeResponse
     * @throws ApiError
     */
    getDeploymentsTree(deliverableType, states) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/tracking/deployments',
            query: {
                'deliverableType': deliverableType,
                'states[]': states,
            },
        });
    }
}
exports.DeliverableTrackingService = DeliverableTrackingService;
